// Entry do SPA Vue 3 do Cortex Gestão.
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from '@/App.vue'
import router from '@/router'
import '@/styles/application.css'
import 'vue-sonner/style.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount('#app')
